import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  AfterViewInit,
  AfterViewChecked
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Roles } from '@app/models/user';
import { camelize } from '@app/utils';
import { getFob } from '@app/product.utils';
import {
  getShipmentFOB,
  getShipmentsUnits,
  getShipmentsTotalFob,
  getCountryFOB
} from '@app/formulas.utils';
import { select, Store } from '@ngrx/store';
import { FollowTypes } from '@app/models/follow';
import { stringify } from '@angular/core/src/util';
import { id } from 'date-fns/esm/locale';
import * as fromProductShipment from '@core/reducers/product-shipment.reducer';
import * as rolesUtils from '@app/role.utils';
// const tyFob = [
//   { name: 'FOB ABIERTO 220', value: 'openFOB220' },
//   { name: 'FOB CERRADO 220', value: 'closedFOB220' },
//   { name: 'FOB ABIERTO 110', value: 'openFOB110' },
//   { name: 'FOB CERRADO 110', value: 'closedFOB110' },
//   { name: 'FOB ABIERTO 220 AR', value: 'openFOB220ARG' },
//   { name: 'FOB CERRADO 220 AR', value: 'closedFOB220ARG' },
//   { name: 'FOB CERRADO', value: 'closedFOB' },
//   { name: 'FOB ABIERTO', value: 'openFOB' },
//   { name: 'FOB regional', value: 'finalFOB' }
// ];

const homeFobTypes = [
  { name: 'FOB ABIERTO', value: 'openFOB' },
  { name: 'FOB CERRADO', value: 'closedFOB' },
  { name: 'FOB CUSTOM', value: 'customFOB' }
];
const petsFobTypes = [{ name: 'FOB cerrado', value: 'closedFOB' }];

const clothingFobTypes = [
  //{ name: 'FOB regional', value: 'regionalFOB' }
  // { name: 'FOB regional', value: 'finalFOB' }
  { name: 'FOB inicial', value: 'initialFOB' },
  { name: 'FOB final', value: 'finalFOB' }
];

const altElectroFobTypes = [
  {
    name: 'FOB ABIERTO 220',
    value: 'openFOB220',
    CountryIds: [43, 173, 30] // Chile, Peru, Brasil
  },
  {
    name: 'FOB CERRADO 220',
    value: 'closedFOB220',
    CountryIds: [43, 173, 30] // Chile, Peru Brasil
  },
  {
    name: 'FOB ABIERTO 110',
    value: 'openFOB110',
    CountryIds: [30, 47] // Brasil, Colombia
  },
  {
    name: 'FOB CERRADO 110',
    value: 'closedFOB110',
    CountryIds: [30, 47] // Brasil, Colombia
  },
  {
    name: 'FOB ABIERTO 220 AR',
    value: 'openFOB220ARG',
    CountryIds: [10] // Argentina
  },
  {
    name: 'FOB CERRADO 220 AR',
    value: 'closedFOB220ARG',
    CountryIds: [10] // Argentina
  }
];

const electroFobTypes = [
  {
    name: 'FOB ABIERTO',
    value: 'openFob'
  },
  {
    name: 'FOB CERRADO',
    value: 'closedFob'
  }
];

@Component({
  selector: 'app-country-shipments',
  templateUrl: './country-shipments.component.html',
  styleUrls: ['./country-shipments.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountryShipmentsComponent implements OnInit {
  @Input()
  selectedProducts;

  @Input()
  productShipments = [];

  @Input()
  valuee: any;

  @Input()
  role;

  @Input()
  follow;

  @Input()
  product;

  @Input()
  followShipments;

  @Input()
  productCountry;

  @Input()
  countryUnitsPerBox;

  @Input()
  chain;

  @Input()
  pcsIdsWithUnits;

  @Input()
  boxValues;

  @Output()
  changeUnits;

  @Input()
  Country;

  @Output()
  edit = new EventEmitter();

  productShipments$ = this.store.pipe(select(fromProductShipment.getAll));
  productShipmentMirror;
  ProductShipmentIds = [];
  fobSelect = {};
  pcsRed;
  boxRed;
  fobTyp = [];
  typeFob = {
    openFOB220: 'FOB ABIERTO 220',
    closedFOB220: 'FOB CERRADO 220',
    openFOB110: 'FOB ABIERTO 110',
    closedFOB110: 'FOB CERRADO 110',
    openFOB220ARG: 'FOB ABIERTO 220 AR',
    closedFOB220ARG: 'FOB CERRADO 220 AR',
    closedFOB: 'FOB CERRADO',
    openFOB: 'FOB ABIERTO',
    initialFOB: 'FOB inicial',
    finalFOB: 'FOB final'
  };

  get shipments() {
    if (this.product && this.product.CountryId) {
      return this.followShipments
        .filter(s => s.CountryId === this.product.CountryId)
        .map((shipment, i) => {
          return {
            name: shipment.departureDate,
            id: shipment.id,
            fuub: this.fobTyp
          };
        });
    } else {
      return [];
    }
  }

  get filteredProductShipments() {
    // console.log('Shipments -> ', this.productShipments);

    if (this.productShipments) {
      if (this.chain) {
        return this.productShipments.filter(
          p =>
            this.shipments.map(s => s.id).includes(p.ShipmentId) &&
            (p.ChainId === this.chain.id || null)
        );
      } else {
        return this.productShipments.filter(p =>
          this.shipments.map(s => s.id).includes(p.ShipmentId)
        );
      }
    } else {
      return [];
    }
  }

  get productShipmentsByFollowShipmentId() {
    // console.log(this.filteredProductShipments)
    // 	if (this.productShipmentMirror) {
    //   return this.productShipmentMirror.reduce((acc, shipment) => {
    //     acc[shipment.ShipmentId] = shipment;

    //     const fob = getShipmentFOB(
    //       this.product,
    //       this.productCountry,
    //       shipment,
    //       this.follow.type,
    //       [
    //         {
    //           default: true,
    //           key: 'initialFOB',
    //           name: 'FOB Inicial'
    //         }
    //       ]
    //     );

    //     return acc;
    //   }, {});
    // } else {
    if (this.filteredProductShipments) {
      return this.filteredProductShipments.reduce((acc, shipment) => {
        acc[shipment.ShipmentId] = shipment;

        const fob = getShipmentFOB(
          this.product,
          this.productCountry,
          shipment,
          this.follow.type,
          [
            {
              default: true,
              key: 'initialFOB',
              name: 'FOB Inicial'
            }
          ]
        );

        return acc;
      }, {});
    } else {
      return {};
    }
    // }
  }

  get unitsPerBox() {
    if (this.product && this.product.metadata && this.productCountry) {
      const countryName = this.Country
        ? this.Country.name
        : this.productCountry.Country.name;
      const countryId = this.Country
        ? this.Country.id
        : this.productCountry.Country.id;
      let fieldName = `boxUnits${countryName}`;
      if (countryId === 173) {
        fieldName = `boxUnitsPeru`
      }
      return (
        this.product.metadata.master || this.product.metadata[fieldName] || 1
      );
    } else {
      return 1;
    }

    return (
      (this.product && this.product.metadata && this.product.metadata.master) ||
      this.countryUnitsPerBox ||
      0
    );
  }

  // get total() {
  //   if (this.filteredProductShipments) {
  //     return this.filteredProductShipments.reduce((sum, shipment) => {
  //       return sum + (shipment.units || 0);
  //     }, 0);
  //   }
  // }

  // get totalBoxes() {
  //   if (this.unitsPerBox) {
  //     return this.total / this.unitsPerBox;
  //   } else {
  //     return 0;
  //   }
  // }

  get isCountryBuyer() {
    return rolesUtils.isCountryUser(this.role);
  }

  get isRegionalBuyer() {
    return this.role === Roles.RegionalBuyer;
  }

  get isPlanner() {
    return rolesUtils.isPlanner(this.role);
  }

  get isProductManager() {
    return rolesUtils.isProductManager(this.role);
  }

  get isQC() {
    return rolesUtils.isSupervisorQC(this.role)
  }

  get currentChains() {
    const business =
      this.productCountry &&
      this.follow.Businesses &&
      this.follow.Businesses.find(b => {
        return (
          b.CountryId === this.productCountry.CountryId &&
          b.code === this.productCountry.businessUnit
        );
      });

    return (business && business.Chains) || [];
  }

  get disabledFOB() {
    if (this.follow.status === 1) {
      return true;
    }
    return false;
  }

  get totalShipmentsUnits() {
    return getShipmentsUnits(this.filteredProductShipments);
  }

  get totalShipmentsBoxes() {
    return this.totalShipmentsUnits / this.unitsPerBox || 0;
  }

  get totalShipmentsFob() {
    if (
      this.product &&
      this.productCountry &&
      this.follow &&
      this.filteredProductShipments
    ) {
      return getShipmentsTotalFob(
        this.product,
        this.productCountry,
        this.follow.type,
        [],
        this.filteredProductShipments
      );
    } else {
      return 0;
    }
  }

  get weightedFOB() {
    return this.totalShipmentsFob / this.totalShipmentsUnits || 0;
  }

  get followStatus() {
    return this.follow.status;
  }

  get followStatusValid() {
    const status = this.follow.status;
    if (
      status === 2 ||
      status === 3 ||
      status === 5 ||
      status === 7 ||
      status === 8
    ) {
      return true;
    } else {
      return false;
    }
  }

  constructor(private store: Store<any>, private fb: FormBuilder) { }

  ngOnInit() {
    if (this.productShipments && this.productShipments.length > 0) {
      this.ProductShipmentIds = this.productShipments.map(x => x.id);
    }

    this.productShipments$.subscribe(x => {
      this.productShipmentMirror = x.filter(pcs =>
        this.ProductShipmentIds.includes(pcs.id)
      );
    });
  }

  showFob(shipment) {
    try {
      const [actualShipment] = this.filteredProductShipments.filter(
        x => x.ShipmentId === shipment.id
      );

      if (this.fobSelect[shipment.id]) {
        return this.fobSelect[shipment.id];
      } else {
        if (actualShipment && actualShipment.fobType && this.follow.type !== 'ALTELECTRO') {
          return this.typeFob[actualShipment.fobType];
        } else if (this.productCountry && this.productCountry.fobType) {
          return this.typeFob[this.productCountry.fobType];
        }
      }

      return '';
    } catch (err) {
      // No console.log(productShipments.length);
    }
  }

  getUnits(id) {
    if (this.pcsIdsWithUnits) {
      this.pcsRed = this.pcsIdsWithUnits.reduce((acc, pcs) => {
        acc[pcs.ShipmentId] = pcs.changes.units;

        return acc;
      }, {});

      if (this.pcsRed[id] >= 0) {
        return this.pcsRed[id];
      } else {
        return -1;
      }
    }
    // const [pcs] = this.productShipments.filter(x => x.id === id)

    // return pcs ? pcs.units || 0 : null;
  }

  getBoxs(id) {
    if (this.boxValues) {
      this.boxRed = this.boxValues.reduce((acc, pcs) => {
        acc[pcs.ShipmentId] = pcs.boxValue;

        return acc;
      }, {});

      if (this.boxRed[id] >= 0) {
        return this.boxRed[id];
      } else {
        return -1;
      }
    }
  }

  emit(e, ShipmentId) {
    const shipments = this.filteredProductShipments || {};
    let value;
    let unitsPerBox = 0;

    // if (this.follow && this.follow.type === 'VESTUARIO') {
    //   if (this.productCountry.metadata.master) {
    //     unitsPerBox = this.productCountry.metadata.master;
    //   }
    // } else {
    //   if (this.product.metadata.master) {
    //     unitsPerBox = this.product.metadata.master;
    //   }
    // }

    try {
      // console.log('Datos value', e.target.value);
      value = parseInt(e.target.value, 10);
    } catch (e) {
      console.error(e);
    }

    const isValid = value % this.unitsPerBox === 0;

    if (!isValid && value !== 0) {
      // Approximate units
      const factor = Math.ceil(value / this.unitsPerBox);
      value = this.unitsPerBox * factor;
    }

    if (this.isCountryBuyer || this.isProductManager) {
      this.edit.emit({
        ShipmentId,
        units: value,
        currentTotalUnits: getShipmentsUnits(this.filteredProductShipments),
        shipments: this.productShipmentsByFollowShipmentId
      });
    }
  }

  emitBoxChange(e, ShipmentId) {
    const shipments = this.filteredProductShipments || {};
    let value;
    try {
      value = parseInt(e.target.value, 10);
    } catch (e) {
      console.error(e);
    }
    if (this.isCountryBuyer || this.isProductManager) {
      this.edit.emit({
        ShipmentId,
        units: value * this.unitsPerBox,
        boxValue: value,
        currentTotalUnits: getShipmentsUnits(this.filteredProductShipments),
        shipments: this.productShipmentsByFollowShipmentId
      });
    }
  }

  emitFobValueChange(e, ShipmentId) {
    const shipments = this.filteredProductShipments || {};
    let value;
    let type;
    let name;
    try {
      this.fobOptions.map(x => {
        if (parseFloat(e.target.value) > 0) {
          value = parseFloat(e.target.value);
          type = x.value;
          name = x.name;
        }
      });
    } catch (e) {
      console.error(e);
    }

    this.fobSelect[ShipmentId] = name;
    if(this.selectedProducts && this.selectedProducts.length > 1){
      // do nothing
    }else{
      this.edit.emit({ ShipmentId, fob: value });
    }
  }

  emitFobChange(e, ShipmentId) {
    const shipments = this.filteredProductShipments || {};
    let value;
    let type;
    let name;
    try {
      this.fobOptions.map(x => {
        if (x.name === e.target.value) {
          value = parseFloat(x.fob);
          type = x.value;
          name = x.name;
        }
      });
    } catch (e) {
      console.error(e);
    }

    this.fobSelect[ShipmentId] = name;

    // if (this.isRegionalBuyer) {
    // this.edit.emit({ ...shipments, [key]: value });
    this.edit.emit({ ShipmentId, fobType: type });
    // }
  }

  getProductShipmentByShipmentId(ShipmentId: number) {
    return (
      this.productCountry &&
      this.productCountry.Shipments &&
      this.productCountry.Shipments.length &&
      this.productCountry.Shipments.find(x => x.ShipmentId === ShipmentId)
    );
  }

  shipmentFOB(shipment) {
    const productShipment = this.getProductShipmentByShipmentId(shipment.id);
    if (this.productShipments) {
      const [currentProductShipment] = this.productShipments.filter(
        x => x.ShipmentId === shipment.id
      );

      if (currentProductShipment && currentProductShipment.fob > 0) {
        return currentProductShipment.fob
      } else if (currentProductShipment && currentProductShipment.fobType) {
        return this.product.metadata[currentProductShipment.fobType] || 0;
      }
    }

    if (!productShipment) {
      return getCountryFOB(
        this.product,
        this.productCountry,
        this.follow.type,
        []
      );
      // return 0;
    }
    return getShipmentFOB(
      this.product,
      this.productCountry,
      productShipment,
      this.follow.type,
      []
    );
  }

  productMaster() {
    if (this.follow && this.follow.type === 'VESTUARIO') {
      return (
        this.productCountry.metadata && this.productCountry.metadata.master
      );
    } else {
      return this.product.metadata && this.product.metadata.master;
    }
  }

  get fobOptions() {
    let types = [];

    switch (this.follow.type) {
      case FollowTypes.Clothing:
        types = clothingFobTypes;
        break;

      case FollowTypes.Food:
      case FollowTypes.Home:
        types = homeFobTypes;
        break;

      case FollowTypes.Electro:
        types = electroFobTypes;
        break;

      case FollowTypes.Pets:
        types = petsFobTypes;
        break;

      case FollowTypes.AltElectro:
        const currentCountryId = this.productCountry.CountryId;
        types = altElectroFobTypes.filter(x =>
          x.CountryIds.includes(currentCountryId)
        );

        break;

      default:
        types = [];
        break;
    }

    types = types.map(item => {
      return {
        ...item,
        fob: this.product.metadata[item.value]
          ? this.product.metadata[item.value]
          : item.value === 'customFOB' ? 0 : null
      };
    });

    return types;
  }

  validate(fobValue) {
    if (!fobValue || !(fobValue > 0)) {
      return true;
    }
  }

  test(e, i) {
    console.log('e', e);
  }
}
